var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65234 11.375C3.68734 11.375 1.27734 8.965 1.27734 6C1.27734 3.035 3.68734 0.625 6.65234 0.625C9.61734 0.625 12.0273 3.035 12.0273 6C12.0273 8.965 9.61734 11.375 6.65234 11.375ZM6.65234 1.375C4.10234 1.375 2.02734 3.45 2.02734 6C2.02734 8.55 4.10234 10.625 6.65234 10.625C9.20234 10.625 11.2773 8.55 11.2773 6C11.2773 3.45 9.20234 1.375 6.65234 1.375Z",
    fill: "#838B97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50766 7.96488C8.44266 7.96488 8.37766 7.94988 8.31766 7.90988L6.76766 6.98488C6.38266 6.75488 6.09766 6.24988 6.09766 5.80488V3.75488C6.09766 3.54988 6.26766 3.37988 6.47266 3.37988C6.67766 3.37988 6.84766 3.54988 6.84766 3.75488V5.80488C6.84766 5.98488 6.99766 6.24988 7.15266 6.33988L8.70266 7.26488C8.88266 7.36988 8.93766 7.59988 8.83266 7.77988C8.75766 7.89988 8.63266 7.96488 8.50766 7.96488Z",
    fill: "#838B97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClock);
export default __webpack_public_path__ + "static/media/ico-clock.2417e7142545d0c916f0b22c47817ab1.svg";
export { ForwardRef as ReactComponent };